import { useUser } from '../../../../state'
import { Component } from './Component'

export const Container = () => {
  const { user } = useUser()

  return <Component showContactSupportAlert={!!user?.credentials.emailConfirmed} />
}
